import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import SidebarContent from "../SidebarContent/SidebarContent.js";
import SidebarNav from "../SidebarNav/SidebarNav.js";
import SidebarNavItem from "../SidebarNavItem/SidebarNavItem.js";
const sidebarVariants = cva(["bg-card-color w-[var(--sidebar-width)]"], {
  variants: {
    position: {
      fixed: "fixed left-0 top-0 pt-[var(--navbar-height)] z-50 h-full border-r border-separator-color-light",
      static: ""
    }
  },
  defaultVariants: {
    position: "fixed"
  }
});
const Sidebar = forwardRef((props, ref) => {
  const { children, position, className, ...rest } = props;
  return /* @__PURE__ */ jsx("nav", { ...rest, ref, className: twMerge(sidebarVariants({ position, className })), children: /* @__PURE__ */ jsx("div", { className: "flex flex-col h-full overflow-y-auto overflow-x-hidden", children }) });
});
Sidebar.Content = SidebarContent;
Sidebar.Nav = SidebarNav;
Sidebar.NavItem = SidebarNavItem;
export {
  Sidebar as default
};
//# sourceMappingURL=Sidebar.js.map
